
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/modules",
      function () {
        return require("private-next-pages/modules.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/modules"])
      });
    }
  